import {
  CloseButton,
  FormTitle,
  HorizontalContainer,
  ScreenRoot,
  SmallTitleText,
  StyledPaper,
  VerticalContainer,
} from "../styles";
import { useMediaQuery } from "react-responsive";
import { StageList } from "../uploader";
import React, { useEffect, useRef, useState } from "react";
import { LargeText, MediumText } from "../../styles";
import { ProceedButtonContainer, TitleContainer } from "../uploader/styles";
import { FunctionalButton } from "../../../../components/functionalButton";
import { Document, Page } from "react-pdf";
import { Dialog } from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import PylonIcon from "assets/common/pylonIcon.png";
import {
  StyledAutoConfirmButton,
  StyledClassificationSkeleton,
  StyledClassifiedNameSelect,
  StyledCustomRadio,
  StyledRadioWrapper,
  StyledPdfThumbnailSkeleton,
  StyledThresholdInput,
  ClassifiedSplitFadeIn,
  AIThinkingButton,
} from "./styles";
import {
  editClassifierData,
  getClassifierData,
  getPdfDocsFromBucket,
} from "../../../../api/external_data";
import { useHistory, useLocation } from "react-router";
import "react-loading-skeleton/dist/skeleton.css";
import {
  getUnderwriterIdpActiveDocuments,
  getUnderwriterIdpArchivedDocuments,
} from "../../../../data/actions/underwriters";
import { useDispatch, useSelector } from "react-redux";
import { contactSelector } from "data/selectors/contact";
import { getContact } from "data/actions/contact";
import { getEntityCredits, setEntityCredits } from "data/actions/user";
import { entityCreditsSelector } from "data/selectors/user";
import functionalCreditCosts from "../../functionalCreditCosts.json";
import { SplitContainer } from "../splitter/styles";
import { CustomPdfViewer } from "../splitter/CustomPdfViewer";
// import { DocumentViewer } from "../components/documentViewer";

// Animated dots component
const AnimatedDots = () => {
  const [dots, setDots] = useState("");

  useEffect(() => {
    const interval = setInterval(() => {
      setDots((prev) => {
        if (prev === "...") return "";
        return prev + ".";
      });
    }, 500);

    return () => clearInterval(interval);
  }, []);

  return (
    <span style={{ display: "inline-block", minWidth: "24px" }}>{dots}</span>
  );
};

// Shimmer effect component
const ShimmerText = ({ children }) => {
  return (
    <span
      style={{
        position: "relative",
        display: "inline-block",
      }}
    >
      {children}
      <span
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          background:
            "linear-gradient(90deg, transparent 0%, rgba(255, 109, 29, 0.3) 50%, transparent 100%)",
          animation: "shimmer 1.5s infinite",
          pointerEvents: "none",
        }}
      />
    </span>
  );
};

const friendlyNames = {
  BALANCE_SHEET: "Balance Sheet",
  TABLE_OF_CONTENT: "Table Of Contents",
  P_AND_L: "Profit And Loss",
  OTHER: "Other",
  CASHFLOW: "Cash Flow",
  WIP: "Work In Progress",
  WORK_COMPLETED: "Work Completed",
  NOTES: "Notes",
  STATEMENT_OF_EQUITY: "Statement of Equity",
};

export default function Classifier() {
  const isMobile = useMediaQuery({ maxWidth: 480 });
  const history = useHistory();

  const dispatch = useDispatch();

  const location = useLocation();

  const {
    selectedAccount,
    clientDocumentsId,
    splitterFiles,
    selectedSubsidiary,
  } = location.state || {};

  const contact = useSelector(contactSelector);
  const entityCredits = useSelector(entityCreditsSelector);

  useEffect(() => {
    if (!contact) {
      dispatch(getContact());
    }
  }, [dispatch, contact]);

  console.log("location.state ", location.state);

  const autoConfirmThresholdSelector = useRef();
  const [rawSplitData, setRawSplitData] = useState([]);
  const [parsedSplits, setParsedSplits] = useState([]);
  const [autoConfirmEnabled, setAutoConfirmEnabled] = useState(false);
  const [autoConfirmHovered, setAutoConfirmHovered] = useState(false);
  const [documentBlobs, setDocumentBlobs] = useState([]);
  const [activeDocumentIndex, setActiveDocumentIndex] = useState(0);
  const isPollingInProgress = useRef(false);
  const [previousResponse, setPreviousResponse] = useState([]);
  const [allSplitsReceived, setAllSplitsReceived] = useState(false);
  const [showProceedErrorPopup, setShowProceedErrorPopup] = useState(false);
  const [showInsufficientCreditsPopup, setShowInsufficientCreditsPopup] =
    useState(false);
  const [isProceeding, setIsProceeding] = useState(false);

  const previousIdsRef = useRef(new Set());

  useEffect(() => {
    if (splitterFiles) {
      console.log("getting docs ", splitterFiles);
      getSplitDocumentsFromBucket(splitterFiles);
    }
  }, []);

  useEffect(() => {
    if (!entityCredits && contact?.user_access_control?.institution_id) {
      dispatch(
        getEntityCredits({
          institution_id: contact?.user_access_control?.institution_id,
        })
      );
    }
  }, [dispatch, entityCredits, contact?.user_access_control?.institution_id]);

  useEffect(() => {
    isPollingInProgress.current = false;
    let pollingInterval;

    const accountDetails = {
      account_id: selectedAccount.AccountId || selectedSubsidiary?.AccountId,
      client_documents_id: clientDocumentsId,
      subsidiary_id: selectedSubsidiary?.SubsidiaryID ?? "",
      user_id: location.state?.userId || "",
    };

    const fetchClassifierData = async () => {
      console.log("fetching classifier data");

      // console.time("classifier");
      if (isPollingInProgress.current) {
        console.log("is polling in progress, returning");
        return;
      }

      isPollingInProgress.current = true;

      try {
        await getClassifierData(
          accountDetails,
          (response) => {
            const isNewDocument = !!splitterFiles;

            if (isNewDocument) {
              console.log("is new document");
              const shouldStopPolling =
                response.status !== "error" &&
                response.message !==
                  "Classifier data is still being processed at IDP" &&
                Array.isArray(response.classifier_data) &&
                Array.isArray(splitterFiles) &&
                splitterFiles.length === response.classifier_data.length;

              if (shouldStopPolling) {
                console.timeEnd("classifier");
                console.timeLog("classifier");
                console.log("stopped polling ");

                setAllSplitsReceived(true);
                dispatch(
                  getUnderwriterIdpActiveDocuments({
                    user_id: location.state?.userId || "",
                  })
                );
                dispatch(
                  getUnderwriterIdpArchivedDocuments({
                    user_id: location.state?.userId || "",
                  })
                );
                clearInterval(pollingInterval);
              } else {
                console.log("stage resumed");
                isPollingInProgress.current = false;
              }

              // if new elements are still coming in
              const previousIds = new Set(
                previousResponse.map((oldElement) => {
                  const oldId = oldElement.files[0].splitFiles[0].id;
                  console.log("Previous ID:", oldId);
                  return oldId;
                })
              );

              // Filter response with logging
              const newElements = response.classifier_data.filter(
                (newElement) => {
                  const newId = newElement.files[0].splitFiles[0].id;
                  const isNew = !previousIdsRef.current.has(newId);
                  console.log("New ID:", newId);
                  console.log(`Is ID ${newId} new?`, isNew);
                  return isNew;
                }
              );

              // If there are new elements, process them
              if (newElements.length > 0) {
                // Add new IDs to previousIdsRef
                newElements.forEach((element) => {
                  const id = element.files[0].splitFiles[0].id;
                  previousIdsRef.current.add(id);
                });

                // Update your state variables
                setPreviousResponse((prevResponse) => [
                  ...prevResponse,
                  ...newElements,
                ]);

                setRawSplitData((prevState) => [...prevState, ...newElements]);
                const parsedResponse = parseSplits(newElements);
                setParsedSplits((prevState) => [
                  ...prevState,
                  ...parsedResponse,
                ]);
              }
            } else {
              clearInterval(pollingInterval);
              setAllSplitsReceived(true);
              dispatch(
                getUnderwriterIdpActiveDocuments({
                  user_id: location.state?.userId || "",
                })
              );
              dispatch(
                getUnderwriterIdpArchivedDocuments({
                  user_id: location.state?.userId || "",
                })
              );
              setRawSplitData(response.classifier_data);
              const parsedResponse = parseSplits(response.classifier_data);
              setParsedSplits(parsedResponse);
              getSplitDocumentsFromBucket(response.classifier_data);
            }
          },
          (error) => {
            console.log(`Failed to get classifier data: ${error}`);
          }
        );
      } catch (e) {
        console.error("Error in fetchClassifierData", e);
      }
    };

    pollingInterval = setInterval(fetchClassifierData, 1000);
    fetchClassifierData();

    return () => clearInterval(pollingInterval);
  }, [location.state?.userId]);

  console.log("splitData ", rawSplitData);
  console.log("splits ", parsedSplits);

  useEffect(() => {
    console.log("docs ", documentBlobs);
  }, [documentBlobs]);

  const handleProceed = async () => {
    if (entityCredits < functionalCreditCosts.idp.classifierToParser) {
      setShowInsufficientCreditsPopup(true);
      return;
    }
    setIsProceeding(true);
    console.log("splts", parsedSplits);
    const modelMappings = {
      P_AND_L: "profitAndLoss",
      CASHFLOW: "cashflow",
      BALANCE_SHEET: "balanceSheet",
      WIP: "workInProgress",
      WORK_COMPLETED: "workCompleted",
    };
    console.log("handleProceed - splitData ", rawSplitData);
    const generateUpdatedClassifierData = () => {
      const mappedOutput = rawSplitData
        .map((doc) => {
          // Map over the files in each document
          const splitFiles = doc.files.flatMap((file) => {
            return file.splitFiles
              .map((splitFile) => {
                const matchingSplit = parsedSplits.find(
                  (splitItem) => splitItem.splitId === splitFile.id
                );
                if (!matchingSplit) {
                  console.log(
                    `No matching split found for splitId: ${splitFile.id}`
                  );
                  return null;
                }
                const activeEntityType = matchingSplit.activeEntity?.type;
                if (activeEntityType && modelMappings[activeEntityType]) {
                  return {
                    id: splitFile.id,
                    bucketName: splitFile.bucketName,
                    filePath: splitFile.filePath,
                    fileName: splitFile.fileName,
                    labellerModel: modelMappings[activeEntityType],
                  };
                } else {
                  console.log(
                    `No valid modelMapping or activeEntity for splitId: ${splitFile.id}`
                  );
                  return null;
                }
              })
              .filter((splitFile) => splitFile !== null); // Remove nulls
          });
          if (splitFiles.length > 0) {
            return {
              id: doc.files[0].id,
              bucketName: doc.files[0]?.bucketName || "",
              filePath: doc.files[0]?.filePath || "",
              fileName: doc.files[0]?.fileName || "",
              splitFiles: splitFiles,
            };
          }
          return null;
        })
        .filter((file) => file !== null);
      console.log("mapped output ", {
        id: rawSplitData[0].id,
        files: [...mappedOutput],
      });
      return {
        id: rawSplitData[0].id,
        files: [...mappedOutput],
      };
    };
    const updatedData = generateUpdatedClassifierData();
    const updatedClassificationData = {
      account_id: selectedAccount.AccountId || selectedSubsidiary?.AccountId,
      client_documents_id: clientDocumentsId,
      labeller_data: updatedData,
      user_id: location.state?.userId || "",
    };
    const pageCounts = await getConfirmedSplitsPageCounts(
      parsedSplits,
      documentBlobs
    );
    console.log("page counts: ", pageCounts);
    await editClassifierData(
      updatedClassificationData,
      (response) => {
        console.log("update data ", updatedData);
        dispatch(
          setEntityCredits(
            {
              user_id: location.state?.userId || "",
              institution_id: contact?.user_access_control?.institution_id,
              updated_entity_credits:
                entityCredits -
                functionalCreditCosts.idp.classifierToParserPerPage *
                  pageCounts,
              deductible_credits:
                functionalCreditCosts.idp.classifierToParserPerPage *
                pageCounts,
            },
            (response) => {
              console.log("response", response);
            },
            () => {
              console.log("failed");
            }
          )
        );
        // if (
        //   selectedAccount.ClassifierThreshold !==
        //   autoConfirmThresholdSelector.current.value
        // ) {
        //   updateClassifierThreshold(
        //     accountDetails,
        //     (response) => {
        //       console.log(
        //         "Successfully updated the classifier threshold value. ",
        //       );
        //     },
        //     (error) => {
        //       console.log(
        //         "Failed to update the classifier threshold value. ",
        //         error,
        //       );
        //     },
        //   );
        // }
        history.push({
          pathname: "/underwriter/idpdocuments/parser",
          state: {
            selectedAccount,
            clientDocumentsId,
            splitFiles: updatedData.files,
            selectedSubsidiary,
            userId: location.state?.userId,
          },
        });
        setIsProceeding(false);
      },
      (error) => {
        console.log("error editing classifier data ", error);
        setIsProceeding(false);
        setShowProceedErrorPopup(true);
      }
    );
  };

  const getSplitDocumentsFromBucket = (splitFiles) => {
    const pdfFiles = [];
    const promises = [];

    splitFiles.forEach((file) => {
      const promise = getPdfDocsFromBucket({
        bucketName: file.bucketName || file.files[0].bucketName,
        filePath: file.filePath || file.files[0].filePath,
      }).then((fetchedBlobs) => {
        const matchingBlob = fetchedBlobs.find(
          (fetchedBlob) =>
            fetchedBlob.fileName === (file.fileName || file.files[0].fileName)
        );

        if (matchingBlob) {
          pdfFiles.push({
            fileName: file.fileName || file.files[0].fileName,
            blob: matchingBlob.blob,
            splitId: file.splitFileId || file.files[0].splitFiles[0].id,
          });
        } else {
          console.warn(`No matching blob found for ${file.fileName}`);
        }
      });

      promises.push(promise);
    });

    Promise.all(promises)
      .then(() => {
        setDocumentBlobs(pdfFiles);
        setActiveDocumentIndex(0); // Set first document as active
        console.log("inside callback pdf files ", pdfFiles);
      })
      .catch((error) => {
        console.error("Error fetching documents:", error);
      });
  };

  const getDocuments = (res) => {
    const pdfFiles = [];
    const promises = [];

    res.forEach((file) => {
      file.files[0].splitFiles.forEach((splitFile) => {
        const promise = getPdfDocsFromBucket({
          bucketName: splitFile.bucketName,
          filePath: splitFile.filePath,
        }).then((fetchedBlobs) => {
          const matchingBlob = fetchedBlobs.find(
            (fetchedBlob) => fetchedBlob.fileName === splitFile.fileName
          );

          if (matchingBlob) {
            pdfFiles.push({
              fileName: splitFile.fileName,
              blob: matchingBlob.blob,
              splitId: splitFile.id,
            });
          } else {
            console.warn(`No matching blob found for ${splitFile.fileName}`);
          }
        });

        promises.push(promise);
      });
    });

    Promise.all(promises)
      .then(() => {
        setDocumentBlobs((prevDocuments) => {
          // Filter to get only new documents that are not already present in the state
          const newDocuments = pdfFiles.filter(
            (newDoc) =>
              !prevDocuments.some(
                (prevDoc) => prevDoc.fileName === newDoc.fileName
              )
          );
          const updatedDocuments = [...prevDocuments, ...newDocuments];

          // Set active document index to first new document if this is the first load
          if (prevDocuments.length === 0 && updatedDocuments.length > 0) {
            setActiveDocumentIndex(0);
          }

          return updatedDocuments;
        });

        console.log("inside callback pdf files ", pdfFiles);
      })
      .catch((error) => {
        console.error("Error fetching documents:", error);
      });
  };

  console.log("outside function pdf files ", documentBlobs);

  const getPdfPageCountFromBlobReactPdf = (blob) => {
    return new Promise((resolve, reject) => {
      const objectURL = URL.createObjectURL(blob);

      const tempDiv = document.createElement("div");
      tempDiv.style.display = "none";
      document.body.appendChild(tempDiv);

      const { Document } = require("react-pdf");
      const React = require("react");
      const ReactDOM = require("react-dom");

      const TempDocument = React.createElement(Document, {
        file: objectURL,
        onLoadSuccess: ({ numPages }) => {
          // Clean up
          URL.revokeObjectURL(objectURL);
          document.body.removeChild(tempDiv);
          resolve(numPages);
        },
        onLoadError: (error) => {
          // Clean up
          URL.revokeObjectURL(objectURL);
          document.body.removeChild(tempDiv);
          reject(error);
        },
      });

      ReactDOM.render(TempDocument, tempDiv);
    });
  };

  const getConfirmedSplitsPageCounts = async (splits, blobs) => {
    const confirmedSplits = splits.filter((split) => split.confirmed);
    let count = 0;

    for (const blob of blobs) {
      const matchingSplit = confirmedSplits.find(
        (split) => split.splitId == blob.splitId
      );

      if (matchingSplit) {
        count += await getPdfPageCountFromBlobReactPdf(blob.blob);
      }
    }

    return count;
  };

  const parseSplits = (res) => {
    let results = [];

    res.forEach((file) => {
      console.log("parsedSplits added a file ", file);
      file.files[0].splitFiles.forEach((splitFile) => {
        console.log("parsedSplits added a splitFile ", splitFile);
        const entities = splitFile.classifierOutput.entities.map((entity) => ({
          id: entity.id,
          type: entity.type,
          confidence: entity.confidence,
          mentionText: entity.mentionText,
        }));

        const highestConfidenceEntity = entities.reduce(
          (maxEntity, entity) =>
            entity.confidence > (maxEntity?.confidence || 0)
              ? entity
              : maxEntity,
          null
        );

        results.push({
          confirmed: false,
          splitId: splitFile.id, // Using splitFile id
          fileId: file.files[0].id, // Ensure this is the correct fileId
          filePath: splitFile.filePath,
          fileName: splitFile.fileName,
          entities: entities,
          activeEntity: highestConfidenceEntity || null,
        });
      });
    });

    console.log("parsed splits results ", results);

    console.log("results.length ", results.length);

    return results;
  };

  const toggleConfirm = (splitId) => {
    setParsedSplits((prevSplits) =>
      prevSplits.map((split) =>
        split.splitId === splitId
          ? { ...split, confirmed: !split.confirmed } // Invert the confirmed value
          : split
      )
    );
  };

  const handleAutoConfirmed = () => {
    const threshold = autoConfirmThresholdSelector.current.value / 100;

    setParsedSplits((prevSplits) =>
      prevSplits.map((split) => {
        if (split.activeEntity && split.activeEntity.confidence >= threshold) {
          return {
            ...split,
            confirmed: true,
          };
        }

        return split;
      })
    );

    setAutoConfirmEnabled(true);
  };

  const handleAutoConfirmDisabled = () => {
    setParsedSplits((prevSplits) =>
      prevSplits.map((split) => {
        return {
          ...split,
          confirmed: false,
        };
      })
    );

    setAutoConfirmEnabled(false);
  };

  /**
   * Handles the change in classified name selection for a specific split.
   *
   * This function updates the `splits` state when the user selects a new value from the dropdown
   * associated with a split. It finds the matching entity by its ID and updates the split's
   * `activeEntity` to that entity, marking the split as confirmed.
   *
   * @param {string} splitId - The unique identifier for the split that is being updated (numeric).
   * @param {string} classifiedNameId - The unique identifier for the selected classified name (numeric).
   */
  const handleClassifiedNameChange = (splitId, classifiedNameId) => {
    setParsedSplits((prevSplits) => {
      return prevSplits.map((split) => {
        if (split.splitId === splitId) {
          const matchingEntity = split.entities.find(
            (entity) => entity.id === classifiedNameId
          );

          return {
            ...split,
            activeEntity: matchingEntity,
            confirmed: true,
          };
        }

        return split;
      });
    });
  };

  const setActiveSplit = (splitId) => {
    console.log("setActiveSplit called with splitId:", splitId);
    const activeDocIndex = documentBlobs.findIndex(
      (doc) => doc.splitId == splitId
    );

    if (activeDocIndex !== -1) {
      setActiveDocumentIndex(activeDocIndex);
    } else {
      console.warn(`No document found with splitId: ${splitId}`);
    }
  };

  return (
    <>
      <ScreenRoot isMobile={isMobile}>
        <VerticalContainer>
          <HorizontalContainer>
            <TitleContainer>
              <LargeText>
                {selectedSubsidiary.SubsidiaryName ||
                  selectedAccount.CompanyName}
              </LargeText>
              <MediumText>
                {selectedAccount.AccountId || selectedSubsidiary.AccountId}
              </MediumText>
            </TitleContainer>
            <StageList
              stages={["Uploader", "Splitter", "Classifier", "Parser"]}
              currentStage="Classifier"
            />
            <ProceedButtonContainer>
              {!allSplitsReceived ? (
                <AIThinkingButton>
                  <span>Processing</span>
                </AIThinkingButton>
              ) : (
                <FunctionalButton
                  buttonTitle={isProceeding ? "Proceeding..." : "Proceed"}
                  handleButton={handleProceed}
                  width="100%"
                  height="48px"
                  isReversedColor={false}
                  marginRight={"48px"}
                  marginLeft={"48px"}
                  marginTop={"48px"}
                  marginBottom={"48px"}
                  fontSize={"16px"}
                  disabled={
                    isProceeding ||
                    !documentBlobs.length > 0 ||
                    !parsedSplits.every((split) => split.confirmed)
                  }
                  icon={null}
                  hasBoxShadow={true}
                  frontIcon={null}
                  weight={600}
                />
              )}
            </ProceedButtonContainer>
          </HorizontalContainer>
          <HorizontalContainer>
            <VerticalContainer
              style={{
                maxHeight: "698px",
                overflowY: "auto",
              }}
            >
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "flex-end",
                  padding: "15px",
                  alignItems: "center",
                }}
              >
                <span style={{ marginRight: "10px" }}>If above </span>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  <StyledThresholdInput
                    ref={autoConfirmThresholdSelector}
                    defaultValue={
                      selectedAccount.ClassifierThreshold ||
                      selectedSubsidiary.ClassifierThreshold ||
                      90
                    }
                    type="number"
                    min="0"
                    max="100"
                  />
                </div>
                <span style={{ padding: "0 5px" }}>%</span>
                <StyledAutoConfirmButton
                  title="Set the confidence score threshold to auto-confirm all labels in the box, then click here."
                  enabled={autoConfirmEnabled}
                  onMouseEnter={() => setAutoConfirmHovered(true)}
                  onMouseLeave={() => setAutoConfirmHovered(false)}
                  onClick={() =>
                    autoConfirmEnabled
                      ? handleAutoConfirmDisabled()
                      : handleAutoConfirmed()
                  }
                >
                  Auto Confirm
                </StyledAutoConfirmButton>
              </div>
              {documentBlobs.length > 0 ? (
                (() => {
                  const processedFiles = new Set();
                  console.log("split data length", rawSplitData.length);
                  return rawSplitData.map((data) => {
                    return data.files.map((file) => {
                      if (!processedFiles.has(file.id)) {
                        processedFiles.add(file.id);

                        const relatedSplits = parsedSplits.filter(
                          (split) => split.fileId === file.id
                        );

                        if (relatedSplits.length > 0) {
                          return (
                            <div key={file.id} style={{ padding: "30px 0" }}>
                              <MediumText>{file.fileName}</MediumText>

                              {relatedSplits.map((split) => (
                                <ClassifiedSplitFadeIn key={split.splitId}>
                                  <ClassifiedSplit
                                    onClick={() =>
                                      setActiveSplit(split.splitId)
                                    }
                                    split={split}
                                    document={documentBlobs.find(
                                      (document) =>
                                        split.splitId === document.splitId
                                    )}
                                    confirmed={split.confirmed}
                                    toggleConfirm={toggleConfirm}
                                    onClassifiedNameChange={
                                      handleClassifiedNameChange
                                    }
                                    splitSelect={setActiveSplit}
                                    autoConfirmHovered={autoConfirmHovered}
                                    threshold={
                                      autoConfirmThresholdSelector.current
                                        ?.value || 50
                                    }
                                  />
                                </ClassifiedSplitFadeIn>
                              ))}
                            </div>
                          );
                        } else {
                          return null;
                        }
                      } else {
                        return null;
                      }
                    });
                  });
                })()
              ) : (
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "8px",
                  }}
                >
                  <StyledClassificationSkeleton></StyledClassificationSkeleton>
                  <StyledClassificationSkeleton></StyledClassificationSkeleton>
                  <StyledClassificationSkeleton></StyledClassificationSkeleton>
                  <StyledClassificationSkeleton></StyledClassificationSkeleton>
                  <StyledClassificationSkeleton></StyledClassificationSkeleton>
                  <StyledClassificationSkeleton></StyledClassificationSkeleton>
                  <StyledClassificationSkeleton></StyledClassificationSkeleton>
                </div>
              )}
            </VerticalContainer>
            <VerticalContainer>
              <div
                style={{
                  margin: "0 72px",
                  width: "600px",
                  minHeight: "700px",
                }}
              >
                <CustomPdfViewer
                  documents={documentBlobs}
                  activeDocument={
                    documentBlobs[activeDocumentIndex] || documentBlobs[0]
                  }
                  onDocumentChange={(document) => {
                    if (document) {
                      setActiveSplit(document.splitId);
                    }
                  }}
                />
              </div>
            </VerticalContainer>
          </HorizontalContainer>
        </VerticalContainer>
      </ScreenRoot>
      <Dialog
        open={showInsufficientCreditsPopup}
        setOpen={setShowInsufficientCreditsPopup}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        maxWidth="md"
      >
        <StyledPaper elevation={0}>
          <CloseButton
            aria-label="close"
            onClick={() => {
              setShowInsufficientCreditsPopup(false);
            }}
          >
            <CloseIcon />
          </CloseButton>
          <img src={PylonIcon} />
          <FormTitle
            style={{
              margin: "10px 0",
              color: "#1A051D",
              fontSize: "22px",
              fontWeight: "600",
              fontStyle: "normal",
              lineHeight: "24px",
            }}
          >
            Insufficient Credits
          </FormTitle>
          <SmallTitleText>
            You don't have enough credits to proceed to the parser stage. Please
            purchase more credits or contact your administrator.
          </SmallTitleText>
          <div style={{ display: "flex", gap: "24px", width: "100%" }}>
            <FunctionalButton
              buttonTitle="Go Back to Dashboard"
              handleButton={() => history.push("/underwriter/idpdocuments")}
              height="48px"
              isReversedColor={true}
              marginTop={"30px"}
              marginBottom={"20px"}
              fontSize={"18px"}
              disabled={false}
              icon={null}
              hasBoxShadow={true}
              frontIcon={null}
              weight={600}
              style={{
                flex: 1,
                whiteSpace: "nowrap",
              }}
            />
            <FunctionalButton
              buttonTitle="Close"
              handleButton={() => setShowInsufficientCreditsPopup(false)}
              height="48px"
              isReversedColor={false}
              marginTop={"30px"}
              marginBottom={"20px"}
              fontSize={"18px"}
              disabled={false}
              icon={null}
              hasBoxShadow={true}
              frontIcon={null}
              weight={600}
              style={{
                flex: 1,
                whiteSpace: "nowrap",
              }}
            />
          </div>
        </StyledPaper>
      </Dialog>
      <Dialog
        open={showProceedErrorPopup}
        setOpen={setShowProceedErrorPopup}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        maxWidth="md"
      >
        <StyledPaper elevation={0}>
          <CloseButton
            aria-label="close"
            onClick={() => {
              setShowProceedErrorPopup(false);
            }}
          >
            <CloseIcon />
          </CloseButton>
          <img src={PylonIcon} />
          <FormTitle
            style={{
              margin: "10px 0",
              color: "#1A051D",
              fontSize: "22px",
              fontWeight: "600",
              fontStyle: "normal",
              lineHeight: "24px",
            }}
          >
            Error Proceeding
          </FormTitle>
          <SmallTitleText>
            There was an error proceeding to the parser stage. Please try again
            or contact PledgX at support@pledgx.ai if the problem persists.
          </SmallTitleText>
          <div style={{ display: "flex", gap: "24px", width: "100%" }}>
            <FunctionalButton
              buttonTitle="Go Back to Dashboard"
              handleButton={() => history.push("/underwriter/idpdocuments")}
              height="48px"
              isReversedColor={true}
              marginTop={"30px"}
              marginBottom={"20px"}
              fontSize={"18px"}
              disabled={false}
              icon={null}
              hasBoxShadow={true}
              frontIcon={null}
              weight={600}
              style={{
                flex: 1,
                whiteSpace: "nowrap",
              }}
            />
            <FunctionalButton
              buttonTitle="Close"
              handleButton={() => setShowProceedErrorPopup(false)}
              height="48px"
              isReversedColor={false}
              marginTop={"30px"}
              marginBottom={"20px"}
              fontSize={"18px"}
              disabled={false}
              icon={null}
              hasBoxShadow={true}
              frontIcon={null}
              weight={600}
              style={{
                flex: 1,
                whiteSpace: "nowrap",
              }}
            />
          </div>
        </StyledPaper>
      </Dialog>
    </>
  );
}

const ClassifiedSplit = ({
  split,
  document,
  confirmed,
  toggleConfirm,
  onClassifiedNameChange,
  splitSelect,
  autoConfirmHovered,
  threshold,
}) => {
  const [pageCount, setPageCount] = useState();
  const [isLoading, setIsLoading] = useState(true);
  const [hasTimedOut, setHasTimedOut] = useState(false);
  const timeoutRef = useRef();

  const onLoadSuccess = ({ numPages }) => {
    setPageCount(numPages);
    setIsLoading(false);
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }
  };

  const onLoadError = () => {
    setIsLoading(false);
    setHasTimedOut(true);
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }
  };

  // Set up 3-second timeout
  useEffect(() => {
    setIsLoading(true);
    setHasTimedOut(false);

    timeoutRef.current = setTimeout(() => {
      setIsLoading(false);
      setHasTimedOut(true);
    }, 3000);

    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, [document.blob]);

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        gap: "70px",
        boxShadow: "0px 2px 6px 0px #0000000F",
        backgroundColor: "white",
      }}
    >
      {/*Page thumbnail and classified name dropdown*/}
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "center",
          alignItems: "center",
          gap: "20px",
        }}
      >
        <div
          onClick={() => splitSelect(split.splitId)}
          style={{
            padding: "5px 20px",
            backgroundColor: "#EBE9F1BF",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            cursor: "pointer",
          }}
        >
          <div style={{ position: "relative", width: "38px", height: "48px" }}>
            {/* Always render the Document component so it can start loading */}
            <div
              style={{
                position: "absolute",
                top: 0,
                left: 0,
                opacity: !isLoading && !hasTimedOut ? 1 : 0,
                transition: "opacity 0.2s",
              }}
            >
              <Document
                file={document.blob}
                onLoadSuccess={onLoadSuccess}
                onLoadError={onLoadError}
              >
                <Page
                  pageNumber={1}
                  width="38"
                  height="48"
                  devicePixelRatio={1}
                  renderMode="canvas"
                  renderAnnotationLayer={false}
                  renderTextLayer={false}
                />
              </Document>
            </div>

            {/* Show skeleton loader while loading */}
            {isLoading && !hasTimedOut && (
              <div style={{ position: "absolute", top: 0, left: 0 }}>
                <StyledPdfThumbnailSkeleton />
              </div>
            )}

            {/* Show white placeholder if timed out */}
            {hasTimedOut && (
              <div
                style={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  width: "38px",
                  height: "48px",
                  backgroundColor: "white",
                  border: "1px solid #e0e0e0",
                  borderRadius: "4px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <span style={{ fontSize: "8px", color: "#999" }}>PDF</span>
              </div>
            )}
          </div>
          <span style={{ fontSize: "10px" }}>
            {pageCount} {pageCount > 1 ? "pages" : "page"}
          </span>
        </div>
        {/*Dropdown with names*/}
        <div>
          <StyledClassifiedNameSelect
            onChange={(e) =>
              onClassifiedNameChange(split.splitId, e.target.value)
            }
          >
            {(() => {
              const entities = split.entities;
              const existingTypes = entities.map((entity) => entity.type);

              // Fill with missing types
              Object.keys(friendlyNames).forEach((classificationType) => {
                const isMissingType =
                  !existingTypes.includes(classificationType);

                isMissingType &&
                  entities.push({
                    confidence: 0,
                    type: classificationType,
                  });
              });

              return entities
                .sort((a, b) => b.confidence - a.confidence)
                .map((entity) => {
                  return (
                    <option key={entity.id} value={entity.id}>
                      {friendlyNames[entity.type] || entity.type} -{" "}
                      {(entity.confidence * 100).toFixed(2)}%
                    </option>
                  );
                });
            })()}
          </StyledClassifiedNameSelect>
        </div>
      </div>
      {/*confirm radio button*/}
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          padding: "25px",
          cursor: "pointer",
        }}
      >
        <StyledRadioWrapper>
          <StyledCustomRadio
            name="confirm-radio"
            onClick={() => toggleConfirm(split.splitId)}
            confirmed={confirmed}
            autoConfirmHovered={autoConfirmHovered}
            wouldBeConfirmed={
              split.activeEntity &&
              split.activeEntity.confidence >= threshold / 100
            }
          />
        </StyledRadioWrapper>
      </div>
    </div>
  );
};

const DownChevron = () => (
  <svg
    width="7"
    height="5"
    viewBox="0 0 7 5"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.60293 0.5C0.748577 0.5 0.287669 1.50212 0.843675 2.15079L2.95517 4.6142C3.35426 5.07981 4.07459 5.07981 4.47368 4.6142L6.58518 2.15079C7.14118 1.50212 6.68027 0.5 5.82592 0.5H1.60293Z"
      fill="#B9B9C3"
    />
  </svg>
);
